import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom";
import { ReserSaveMarketsegment, ReservationMarketSegmentApi } from "../../Services/Service";
import swal from "sweetalert";
import ReservationSidebar from "../Commun/ReservationSidebar";
import ReservationHeader from "../Commun/ReservationHeader";
import { useProperty } from "../../PropertyContext";

export const ReservationMarketSegment = () => {
    const location = useLocation();
    const { selectedProperty } = useProperty();
    const [marketSegment, setMarketSegment] = useState([]);
    const [showSuccess, setShowSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([{ code: "", segment: "" }]);
    const [selectedRow, setSelectedRow] = useState({ ID: 0, Code: "", MarketSeg: "" });
    const [, setFormData] = useState({
        ID: 0,
        Code: "",
        MarketSeg: ""
    });

    useEffect(() => {
        if (location.state?.success) {
            setSuccessMessage(location.state.success);
            setShowSuccess(true);

            setTimeout(() => setShowSuccess(false), 4000);
        }
    }, [location.state]);

    useEffect(() => {
        const FetchMArketSegment = async () => {
            setLoading(true);
            try {
                const result = await ReservationMarketSegmentApi(selectedProperty?.PropertyID);
                // setMarketSegment(result || []);
                if (Array.isArray(result)) setMarketSegment(result);
            }
            catch (error) {
                console.log("error fetching market segment", error);
            } finally {
                setLoading(false);
            }
        }
        FetchMArketSegment();
    }, [selectedProperty]);

    const handleAddRow = () => {
        setRows([...rows, { code: "", segment: "" }]);
    };

    const handleDeleteRow = (index) => {
        setRows(rows.filter((_, i) => i !== index));
    };

    const handleChange = (index, field, value) => {
        const newRows = [...rows];
        newRows[index][field] = value;
        setRows(newRows);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {

            for (let row of rows) {
                if (!row.code || !row.segment) {
                    swal("Please enter Code and select Market Segment !", {
                        icon: "warning",
                        buttons: {
                            confirm: {
                                text: "OK",
                                className: "btn btn-warning",
                            },
                        },
                    });
                    setLoading(false);
                    return;
                }
            }
            // Loop through all rows and submit each
            for (let row of rows) {
                const formdata = {
                    PropID: selectedProperty?.PropertyID,
                    ID: 0,
                    Code: row.code,
                    MarketSeg: row.segment
                };
                await ReserSaveMarketsegment(formdata);
            }

            swal("Market Segment Added Successfully", {
                icon: "success",
                buttons: {
                    confirm: {
                        text: "OK",
                        className: "btn btn-success",
                    },
                },
            }).then(() => {
                const modal = window.bootstrap.Modal.getInstance(
                    document.getElementById("Add-market-Segment")
                );
                if (modal) modal.hide();
            });

            // Reset rows
            setRows([{ code: "", segment: "" }]);
            setFormData({ ID: 0, Code: "", MarketSeg: "" });

            const result = await ReservationMarketSegmentApi(selectedProperty?.PropertyID);
            if (Array.isArray(result)) setMarketSegment(result);

        } catch (error) {
            console.log("Error adding market segment", error);
            alert("Failed to add market segment!");
        } finally {
            setLoading(false);
        }
    };


    const handleEditClick = (row) => {
        setSelectedRow(row);
    };

    // Handle input change inside Update modal
    const handleUpdateChange = (field, value) => {
        setSelectedRow((prev) => ({ ...prev, [field]: value }));
    };

    // Handle update submit
    const handleUpdate = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const formdata = {
                PropID: selectedProperty?.PropertyID,
                ID: selectedRow.ID, // IMPORTANT: existing ID for update
                Code: selectedRow.Code,
                MarketSeg: selectedRow.MarketSeg,
            };

            await ReserSaveMarketsegment(formdata);

            swal("Market Segment Updated Successfully", {
                icon: "success",
                buttons: {
                    confirm: {
                        text: "OK",
                        className: "btn btn-success",
                    },
                },
            }).then(() => {
                const modal = window.bootstrap.Modal.getInstance(
                    document.getElementById("Update-market-Segment")
                );
                if (modal) modal.hide();
            });

            // Refresh list
            const result = await ReservationMarketSegmentApi(selectedProperty?.PropertyID);
            if (Array.isArray(result)) setMarketSegment(result);

        } catch (error) {
            console.log("Error updating market segment", error);
            alert("Failed to update market segment!");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}

            <div className="wrapper">
                <ReservationSidebar />
                <div className="main-panel">
                    <ReservationHeader />

                    <div className="container">
                        <div className="page-inner">
                            <div className="row">
                                <div className="col-md-12">

                                    {showSuccess && (
                                        <div className="alert alert-success d-flex align-items-center" role="alert">
                                            <i className="feather-check-circle flex-shrink-0 me-2"></i>
                                            <div>{successMessage}</div>
                                        </div>
                                    )}



                                    <div className="card">
                                        <div className="card-header">
                                            <h4 className="card-title">Market Segment List</h4>
                                        </div>
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <div className="text-end mb-2">
                                                    <button type="button" className="btn btn-primary btn-sm waves-effect waves-light mt-1" data-bs-toggle="modal" data-bs-target="#Add-market-Segment">Add </button>
                                                </div>
                                                <table
                                                    className="display table table-striped table-hover basic-datatables"
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th>Code</th>
                                                            <th>Market Segment</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {marketSegment.length > 0 ? (
                                                            marketSegment.map((item) => (
                                                                <tr key={item.ID}>
                                                                    <td>{item.Code}</td>
                                                                    <td>{item.MarketSeg}</td>
                                                                    <td>
                                                                        <button type="button" className="btn btn-primary btn-sm waves-effect waves-light py-1 px-2" data-bs-toggle="modal" data-bs-target="#Update-market-Segment" onClick={() => handleEditClick(item)}><i className="fas fa-edit"></i> </button>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="3" className="text-center">
                                                                    No data found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>


                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* market segment modal content */}
                    <div
                        id="Add-market-Segment"
                        className="modal fade"
                        tabIndex={-1}
                        role="dialog"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">Add Market Segment</h4>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    />
                                </div>
                                <div className="modal-body">
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th style={{ width: "152px" }}>Code</th>
                                                <th>Market Segment</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {rows.map((row, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Code"
                                                            value={row.code}
                                                            onChange={(e) =>
                                                                handleChange(index, "code", e.target.value)
                                                            }
                                                            required
                                                        />
                                                    </td>
                                                    <td>
                                                        <input type="text" className="form-control" placeholder="Enter Market Segment"
                                                            value={row.segment}
                                                            onChange={(e) => handleChange(index, "segment", e.target.value)}
                                                            required
                                                        />
                                                    </td>
                                                    <td className="text-center">
                                                        {index !== 0 && (
                                                            <button
                                                                className="btn btn-sm text-danger fs-6"
                                                                onClick={() => handleDeleteRow(index)}
                                                            >
                                                                <i className="fas fa-trash"></i>
                                                            </button>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div className="text-end">
                                        <button className="btn btn-sm btn-primary" onClick={handleAddRow}>
                                            Add
                                        </button>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-info waves-effect waves-light"
                                        onClick={handleSubmit}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /.modal */}

                    {/* Update Market Segment Model */}
                    <div
                        id="Update-market-Segment"
                        className="modal fade"
                        tabIndex={-1}
                        role="dialog"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">Add Market Segment</h4>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    />
                                </div>
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <label className="form-label">Code</label>
                                        <input type="text" className="form-control" value={selectedRow.Code || ""}
                                            onChange={(e) => handleUpdateChange("Code", e.target.value)}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Market Segment</label>
                                        <input type="text" className="form-control" value={selectedRow.MarketSeg || ""}
                                            onChange={(e) => handleUpdateChange("MarketSeg", e.target.value)} />
                                    </div>

                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-info waves-effect waves-light"
                                        onClick={handleUpdate}
                                    >
                                        Update
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

        </>
    )
}
